import { TFunction } from "i18next";
import { ICardTypeMetadata } from '../../cardTypes'

export const getInitIncidentAdaptiveCard = (t: TFunction) => {

    return (
        {
            "$schema": "http://adaptivecards.io/schemas/adaptive-card.json",
            "type": "AdaptiveCard",
            "version": "1.2",
            "backgroundImage": {
                "url": "/Content/colors/F5E6E5.png"
            },
            "body": [
                {
                    "type": "Container",
                    "spacing": "Default",
                    "items": [
                        {
                            "type": "Image",
                            "spacing": "none",
                            "url": "/Content/Banner - Major IT Incident Summary Report - IT Alert.png",
                            "size": "Stretch",
                            "width": "400px",
                            "altText": ""
                        }
                    ],
                },
                {
                    "type": "Container",
                    "spacing": "Default",
                    "items": [
                        {
                            "type": "TextBlock",
                            "weight": "Bolder",
                            "text": "INITIAL/UPDATE # X /RESOLVED: Severity/Priority | Networks(s) | Location | Issue Description | Ticket #INC0XXXXXX",
                            "size": "Default",
                            "wrap": true,
                        },
                        {
                            "type": "TextBlock",
                            "weight": "Bolder",
                            "text": "Severity / Priority",
                            "size": "Default",
                            "wrap": false,
                            "spacing": "Default"
                        },
                        {
                            "type": "TextBlock",
                            "text": "",
                            "size": "Small",
                            "wrap": true,
                            "spacing": "None"
                        },
                        {
                            "type": "TextBlock",
                            "weight": "Bolder",
                            "text": "OMC IT Area(s) Involved",
                            "size": "Default",
                            "wrap": false,
                            "spacing": "Default",
                            "separator": true
                        },
                        {
                            "type": "RichTextBlock",
                            "spacing": "None",
                            "inlines": [
                                {
                                    "type": "TextRun",
                                    "text": ""
                                }
                            ]
                        },
                        {
                            "type": "TextBlock",
                            "weight": "Bolder",
                            "text": "OMG Networks Affected",
                            "size": "Default",
                            "wrap": false,
                            "spacing": "Default",
                            "separator": true
                        },
                        {
                            "type": "TextBlock",
                            "text": "",
                            "size": "Small",
                            "wrap": true,
                            "spacing": "None",
                        },
                        {
                            "type": "TextBlock",
                            "weight": "Bolder",
                            "text": "Agencies Affected",
                            "size": "Default",
                            "wrap": false,
                            "spacing": "Default",
                            "separator": true
                        },
                        {
                            "type": "TextBlock",
                            "text": "",
                            "size": "Small",
                            "wrap": true,
                            "spacing": "None",
                        },
                        {
                            "type": "TextBlock",
                            "weight": "Bolder",
                            "text": "Issues Start Time",
                            "size": "Default",
                            "wrap": false,
                            "spacing": "Default",
                            "separator": true
                        },
                        {
                            "type": "TextBlock",
                            "text": "",
                            "size": "Small",
                            "wrap": true,
                            "spacing": "None",
                        },
                        {
                            "type": "TextBlock",
                            "weight": "Bolder",
                            "text": "Service Impact",
                            "size": "Default",
                            "wrap": false,
                            "spacing": "Default",
                            "separator": true
                        },
                        {
                            "type": "TextBlock",
                            "text": "",
                            "size": "Small",
                            "wrap": true,
                            "spacing": "None",
                        },
                        {
                            "type": "Container",
                            "items": [
                            ],
                        }
                    ],
                },

            ],
        }
    );
}

export const getCardTitle = (card: any) => {
    return card.body[1].items[0].text;
}

export const setIncidentCardTitle = (card: any, title: string) => {
    card.body[1].items[0].text = title;
}

export const getSeverity = (card: any) => {
    return card.body[1].items[2].text;
}

export const setSeverity = (card: any, severity: string) => {
    card.body[1].items[2].text = severity;
}

export const getAreaInvolved = (card: any) => {
    return card.body[1].items[4].text;
}

export const setAreaInvolved = (card: any, area: string[]) => {
    if (area.length > 0)
        card.body[1].items[4].inlines[0].text = area.join('\n').trim();
}

export const setNetworkAffected = (card: any, networkAffected: string) => {
    card.body[1].items[6].text = networkAffected;
}

export const setAgencyAffected = (card: any, AgencyAffected: string) => {
    card.body[1].items[8].text = AgencyAffected;
}

export const setIssueStartTime = (card: any, date: string) => {
    card.body[1].items[10].text = date;
}

export const setServiceImpact = (card: any, serviceImpact: string) => {
    card.body[1].items[12].text = serviceImpact;
}

export const setLatestUpdate = (card: any, latestUpdate: string, latestUpdateDate?: string) => {
    card.body[1].items[13].items = [];

    if (latestUpdate) {
        card.body[1].items[13].items = []
        card.body[1].items[13].items.push({
            "type": "Container",
            "items": [
                {
                    "type": "TextBlock",
                    "text": "Latest Update",
                    "wrap": false,
                    "horizontalAlignment": "Center",
                    "weight": "Bolder",
                    "spacing": "None"
                },
                {
                    "type": "RichTextBlock",
                    "inlines": [
                        {
                            "type": "TextRun",
                            "text": latestUpdate
                        }
                    ]
                },
                {
                    "type": "TextBlock",
                    "text": latestUpdateDate,
                    "size": "Small",
                    "wrap": true,
                    "spacing": "None",
                }
            ],
            "style": "emphasis",
        });
    } else {
        card.body[1].items[13].items = []
    }
}

export const getCardBtnTitle = (card: any) => {
    return card.actions[1].title;
}

export const getCardBtnLink = (card: any) => {
    return card.actions[1].url;
}

export const setCardStyle = (card: any, cardTypes: { [key: string]: ICardTypeMetadata }, updateType?: string,) => {
    if (cardTypes && updateType) {
        const cardMetadata = cardTypes[updateType];
        if (cardMetadata) {
            card.backgroundImage.url = `/Content/colors/${cardMetadata.color}.png`;
            card.body[0].items[0].url = `/Content/${cardMetadata.logo}`;
        }
    } else { }
}

export const setActionsIncident = (card: any, actions: any[]) => {
    let urlsAndEvents: any[] = actions ? [...actions] : []


    if (urlsAndEvents.length !== 0) {

        card.actions = []
        urlsAndEvents.forEach(x => card.actions.push({
            "type": "Action.OpenUrl",
            "title": x.title === "" ? "Button" : x.title,
            "url": x.link
        }))
    } else {
        delete card.actions;
    }

}


